import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";
import { initialDocumentState } from "../../models/documentModel";

export const fetchDocument = createAsyncThunk(
  "document/fetchDocument",
  async (_, thunkAPI) => {
    try {
      const response = await apiService("/Document/GetAll");
      if (response.isSuccess) {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response.message || "Hata oluştu");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const documentSlice = createSlice({
  name: "document",
  initialState: initialDocumentState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDocument = action.payload;
      })
      .addCase(fetchDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default documentSlice.reducer;
